import React, { useEffect, useRef, useState } from "react";
import cdwn from "./NewUiimg/complain-arrow.png";
import Complaint from "./NewUiimg/Complaint.png";
import complaintgrp from "./NewUiimg/complaintsgrp.png";
import suggest from "./NewUiimg/suggest.png";
import symptompng from "./NewUiimg/symptom.png";
import "./schoolOverview.css";

const SchoolOverViewComponent = ({
  fetchEpisodeStats,
  organizationId,
  stats,
  reportData,
}) => {
  const [selectedOption, setSelectedOption] = useState("Today");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    fetchEpisodeStats(organizationId, selectedOption, null, null);
  }, [selectedOption]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const { class: classData } = reportData || {};

  const flexRow = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };

  const handleOptionClick = (option) => {
    const newOption =
      option === "week" || option === "month" ? `This ${option}` : option;
    setSelectedOption(newOption);
    setIsDropdownOpen(false);
  };

  const renderEpisodeValue = () => {
    switch (selectedOption) {
      case "This week":
        return stats.weekly_episodes;
      case "This month":
        return stats.monthly_episodes;
      case "All":
        return stats.all_episodes;
      default:
        return stats.daily_report?.episodes;
    }
  };

  const renderDataSection = (icon, title, dataArray) => (
    <div
      className="partline"
      style={{
        display: "flex",
        flexDirection: "column",
        paddingBottom: "7px",
        padding: "0 20px",
      }}
    >
      <div style={{ ...flexRow, gap: 5, padding: "10px 0" }}>
        <img className="complaintsgrp_png" src={icon} alt={title} />
        <div className="complaintsgrptxt">{title}</div>
      </div>
      <div style={{ ...flexRow, flexWrap: "wrap" }}>
        {dataArray && dataArray.length > 0 ? (
          dataArray?.map((data, index) => (
            <div
              key={index}
              style={{
                ...flexRow,
                justifyContent: "space-between",
                alignItems: "center",
                flexBasis: "33%",
                padding: "5px 0",
              }}
            >
              <div style={{ ...flexRow, flex: 1, gap: 4, padding: "10px 0px" }}>
                <text
                  style={{
                    backgroundColor: "#f2f7fc",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontFamily: "Montserrat",
                    fontWeight: 600,
                  }}
                >
                  {data.count || "-"}
                </text>
                <text
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: 500,
                    fontSize: 16,
                  }}
                  className=" label-txtV2"
                >
                  {data.node}
                </text>
              </div>
            </div>
          ))
        ) : (
          <div
            className="label-txtV2 "
            style={{ marginLeft: "30px", paddingBottom: "10px" }}
          >
            No Data Available
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div
      style={{
        flex: 1,
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      {/* Header Section */}
      <div
        className="partline"
        style={{
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontWeight: 600,
          ...flexRow,
          justifyContent: "space-between",
          padding: "10px 20px",

          alignItems: "center",
        }}
      >
        <text>TODAY</text>

        {/* ✅ Custom Dropdown */}
        <div
          ref={dropdownRef}
          style={{ position: "relative", minWidth: "140px" }}
        >
          <button
            type="button"
            className="btn btn-white complain-btn"
            onClick={() => setIsDropdownOpen((prev) => !prev)}
            style={{
              width: "100%",
              justifyContent: "space-between",
              display: "flex",
              alignItems: "center",
              padding: "6px 12px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              cursor: "pointer",
              backgroundColor: "#F2F7FC",
              border: "none",
            }}
          >
            <span className="complaintodaytxt">{selectedOption}</span>
            <img
              className="complaindownarrow"
              src={cdwn}
              alt="down arrow"
              style={{
                width: "14px",
                height: "14px",
                transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
            />
          </button>

          {isDropdownOpen && (
            <ul
              className="dropdown-menu show"
              style={{
                position: "absolute",
                top: "110%",
                left: 0,
                width: "100%",
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "6px",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                listStyle: "none",
                padding: 0,
                margin: 0,
                zIndex: 10,
                overflow: "hidden",
              }}
            >
              {["Today", "week", "month", "All"].map((opt) => (
                <li
                  key={opt}
                  onClick={() => handleOptionClick(opt)}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight:
                      (opt === "week"
                        ? "This week"
                        : opt === "month"
                        ? "This month"
                        : opt) === selectedOption
                        ? 500
                        : 400,
                    backgroundColor:
                      (opt === "week"
                        ? "This week"
                        : opt === "month"
                        ? "This month"
                        : opt) === selectedOption
                        ? "#f2f7fc"
                        : "transparent",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f8f9fa")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor =
                      (opt === "week"
                        ? "This week"
                        : opt === "month"
                        ? "This month"
                        : opt) === selectedOption
                        ? "#f2f7fc"
                        : "transparent")
                  }
                >
                  {opt === "week" || opt === "month" ? `This ${opt}` : opt}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Student Visited & Episode Completed */}
      <div
        className="partline"
        style={{
          ...flexRow,
          justifyContent: "flex-start",
          padding: "10px 20px",
          gap: 20,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p className="episode-completed">Student Visited</p>
          <div>
            <p className="hsg-sv-label label">
              {stats.daily_report?.students ?? 0}
            </p>
          </div>
        </div>

        <div className="vl-schooloverviewV2"></div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <p className="episode-completed">Episode Completed</p>
          <div>
            <p className="hsg-sv-label label">{renderEpisodeValue()}</p>
          </div>
        </div>
      </div>

      {/* Complaint Stats Header */}
      <div className="partline" style={{ padding: "0 20px" }}>
        <div style={{ ...flexRow, gap: 5, padding: "10px 0" }}>
          <div
            style={{
              ...flexRow,
              backgroundColor: "#f2f7fc",
              borderRadius: "23px",
              gap: 5,
              padding: "10px 30px 10px 20px",
            }}
          >
            <img className="complaintpngV2" src={Complaint} alt="complaint" />
            <text className="TOP-3V2 ">Complaint Stats (Top 3)</text>
          </div>
        </div>
      </div>

      {/* Complaint Data Sections */}
      {stats?.daily_report && (
        <>
          {renderDataSection(
            complaintgrp,
            "Complaints",
            stats.daily_report.complaints
          )}
          {renderDataSection(
            symptompng,
            "Sign/Symptom",
            stats.daily_report.symptoms
          )}
          {renderDataSection(
            suggest,
            "Suggestions/Treatment",
            stats.daily_report.suggestions
          )}
        </>
      )}
    </div>
  );
};

export default SchoolOverViewComponent;
